export default "__VITE_ASSET__CBlJJRod__"